export const ACTION_LOG_KEY = "action-log";
export const STATE_KEY = "unitrack-state";
export const THEME_KEY = "unitrack-theme";
export const DENSITY_KEY = "unitrack-density";
